import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import qs from 'qs'
import Cookies from "js-cookie";
import $ from  'jquery';
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios
Vue.prototype.qs = qs           //全局注册，使用方法为:this.qs
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import _ from "lodash";
Vue.prototype.$_ = _;
Vue.prototype.$jquery = $;
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$Cookies = Cookies;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
